import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeviceAvataar from "./DeviceAvataar";
import IconList, {
  IconListMobile,
  IconListDevMobile,
  EditLineIcons,
} from "./IconList";
import "./NumberCard.scss";
import Highlight from "react-highlighter";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { setEditingID, updateLoader, updateSavingName } from "./action";
import { Category } from "app/utils/categories";
import { RootState } from "app/reducers";
import { resetAssigneeMsisdn, setSelectedLine } from "app/LineDetails/actions";
import {
  sendInvitationInitiated,
  resetInvitation,
  setLongRunningQuery,
  resetToastMessage,
} from "./action/sharedLinesAction";
import ModalDialog from "../ModalDialog/ModalDialog";
import { ComponentsContent } from "./NumberCardContent";
import { success } from "../Snackbar/action";
import { setAttempts, setError } from "./action/pairedLinesAction";
import LineCollapse from "../Collapse";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import UnpairIcon from "../../../assets/icons/icon-special-alert.svg";
// import { deactivateLineAction } from 'app/LineDelve/actions'
import { MyDigitsActionTypes } from "app/LineDetails/actions/index.model";
import { clearApiCallStatus } from "app/actions";
import iconClose from "../../../assets/icons/icon-white-close.svg";
import Tooltip from "../Tooltip";
import { SavingTypes } from "./action/index.model";
import { useMediaQuery } from "react-responsive";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import useOnclickOutside from "react-cool-onclickoutside";

import { isMobileOrTablet } from "app/utils/isMobileOrTablet";

type NumberCardProps = {
  deviceAvataar: string;
  deviceName: string;
  displayNumber: string;
  id: string;
  category: string;
  categoryID: Number;
  searchKey?: any;
  type: string;
  lineType: string;
  granteeID?: string;
  isPared?: boolean;
  pairedDevice?: string;
  isRemovable?: boolean;
  imsi: string;
  isEditable: boolean;
  isShareble: boolean;
  icon?: string;
  removeCB?: (data: any) => void;
  pairCB?: (data: any) => void;
  unpairCB?: (data: any) => void;
  deactivateCB?: (deviceId: string, id: string) => void;
};

export interface ModalObject {
  title: string;
  content: string;
  labelClose: string;
  closeAction: () => void;
  closeActionDisable: boolean;
  modalActionDisable: boolean;
  labelAction: string;
  isPending: boolean;
  closeBtnClass: string;
  status?: string;
  actionBtnClass: string;
}
export interface SnackbarState {
  open: boolean;
  message: string;
}

const NumberCard: React.FC<NumberCardProps> = ({
  deviceAvataar,
  deviceName,
  displayNumber,
  id,
  category,
  categoryID,
  searchKey,
  type,
  granteeID,
  lineType,
  isPared,
  pairedDevice,
  isRemovable,
  removeCB,
  pairCB,
  unpairCB,
  imsi,
  isEditable,
  isShareble,
  icon,
  deactivateCB,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let isMobile = isMobileOrTablet(); // useMediaQuery({ query: "(max-width:769px)" });
  if (useMediaQuery({ query: "(max-width:769px)" })) {
    isMobile = true;
  }
  const CHARACTER_LIMIT = 100;
  const [isHover, setIsHover] = useState(isMobile ? true : false);
  const [contactName, setContactName] = useState(deviceName);
  const [isEdit, setIsEdit] = useState(false);
  const [actionIcons, setActionIcons] = useState<any>();
  const [open, setOpen] = React.useState(false);
  // const [selectedPair, setSelectedPair] = React.useState('')
  const expandMoreRef = React.useRef() as React.MutableRefObject<
    HTMLInputElement
  >;
  const expandLessRef = React.useRef() as React.MutableRefObject<
    HTMLInputElement
  >;

  // const editDeviceRef = React.useRef() as React.MutableRefObject<
  //   HTMLInputElement
  // >;
  const updatedNameID = useSelector(
    (state: RootState) => state.numberCard.updatedId
  );
  const currentEditingID = useSelector(
    (state: RootState) => state.numberCard.currentEditingID
  );

  // const [pairedLines, setParedLines] = React.useState<any>([])
  const sharedLines = useSelector((state: RootState) => state.shareLine);
  const userinfo = useSelector(
    (state: RootState) => state.allLines.userDetails
  );
  const assigneeMsisdn = useSelector(
    (state: RootState) => state.allLines.assigneeMsisdn
  );
  const lineDetails = useSelector(
    (state: RootState) => state.allLines.lineDetails
  );
  //  const selectedLine = useSelector((state: RootState) => state.allLines.selectedLineDetails)
  const deviceList = useSelector(
    (state: RootState) => state.lineDelve.deviceList
  );
  const nameApiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === SavingTypes.UPDATE_SAVING_NAME
    )
  );
  const loading = useSelector((state: RootState) => state.numberCard.loading);
  const lineDeleve = useSelector((state: RootState) => state.lineDelve);
  const content = ComponentsContent?.NumberCard;
  let sharedLinesContent = content.sharedLines;
  const [modelObj, setModelObj] = useState<ModalObject>(
    sharedLinesContent.invitaion
  );
  const pairLineObj = useSelector((state: RootState) => state.pairedLine);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [sharedLineObj, setSharedLineObj] = useState({
    email: "",
    isEmailRequired: true,
    emailDisable: false,
    language: "",
    isAssign: false,
  });
  const [deviceData, setDeviceData] = useState<any>([]);
  // const [deactivateLineData, setDeactivateLineData] = useState<any>('')
  const [isUserEmailExists, setIsUserEmailExists] = useState(false);
  const payload_Iconslist = {
    id: id,
    granteeID: granteeID,
    ganntee: deviceName,
    pairedDevice: pairedDevice,
  };

  //const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  //const openMenu = Boolean(anchorEl);
  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setOpenMenuItem(!openMenu);
  //   //setAnchorEl(event.currentTarget);
  //   console.log(event);
  // };
  // const handleCloseMenu = () => {
  //   if (!isEdit) setAnchorEl(null);
  //   //   if (actionIcons.save.show || currentEditingID === id) {
  //   //   } else{
  //   //   setAnchorEl(null);
  //   // }
  // };

  const [openMenuItem, setOpenMenuItem] = useState(false);

  const handleClickMenu = () => {
    setOpenMenuItem(!openMenuItem);
  };

  const ref = useOnclickOutside(() => {
    if (!(actionIcons.save.show || currentEditingID === id))
      setOpenMenuItem(false);
  });

  // const handleClickBtn = () => {
  //   setOpenMenu(!openMenu);
  // };

  const handleCloseBtn = () => {
    setOpen(false);
    dispatch(clearApiCallStatus({ module: MyDigitsActionTypes.PAIR_LINE }));
    dispatch(clearApiCallStatus({ module: MyDigitsActionTypes.UNPAIR_LINE }));
    dispatch(setAttempts(0));
    dispatch(setError(""));
    if (isUserEmailExists) {
      setIsUserEmailExists(false);
    }
  };

  useEffect(() => {
    if (currentEditingID === id) {
      if (nameApiStatus?.status === "error") {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.serverBusy,
          content:
            "Line name edit was unsuccessful. Please wait a moment and try again.",
          closeAction: closeDialog,
        });
        setOpen(true);
      }
      if (nameApiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          closeAction: closeDialog,
        });
        setOpen(true);
      }
      if (nameApiStatus?.status === "success") {
        closeDialog();
      }
    }
  }, [nameApiStatus?.status, nameApiStatus?.noOfAttempts]);

  const showSelfTag = () => {
    return type === "delveDetails" && deviceName === userinfo.email;
  };
  const lineDeviceName = showSelfTag() ? deviceName + "(Self)" : deviceName;

  const filterPairLines = () => {
    var pairLines: any = [];
    lineDetails.forEach((obj: any) => {
      if (obj.id === 2 || obj.id === 3) {
        obj.lines.forEach((line: any) => {
          if (
            line.LineType === "NORMAL" ||
            line.LineType === "UNKNOWN" ||
            line.LineType === "GSM"
          ) {
            pairLines.push(line);
          }
        });
      }
    });
    return pairLines;
  };

  React.useEffect(() => {
    if (type === "delveDetails") {
      if (!lineDeleve.loading) {
        setOpen(false);
      }
    }
  }, [lineDeleve.error, lineDeleve.loading]);

  React.useEffect(() => {
    if (deviceList===undefined||deviceList?.length === 0) {
      setDeviceData([]);
    }
    if (deviceList && deviceList.length > 0) {
      const userID = granteeID?.split(":")[1];
      const filteredDeviceList = deviceList.filter((item: any) => {
        // const applicationCategoryExists =
        //   ["cdigits", "webdigits"].indexOf(
        //     item?.voiceOverWifiService?.applicationCategory
        //   ) > -1;
        if (
          item.ownerId === userID &&
          item.hasOwnProperty("vimsi") 
          //&& applicationCategoryExists
        ) {
          return true;
        } else {
          return false;
        }
      });
      setDeviceData(filteredDeviceList);
    }
  }, [deviceList]);

  React.useEffect(() => {
    setSharedLineObj({
      ...sharedLineObj,
      emailDisable: false,
      isEmailRequired: false,
    });
  }, [pairLineObj.error, pairLineObj.noofAttempts]);

  React.useEffect(() => {
    if (pairLineObj.loading === true) {
      setModelObj({
        ...modelObj,
        closeActionDisable: true,
        modalActionDisable: true,
        isPending: true,
      });
    } else if (pairLineObj.error === "") {
      setOpen(false);
    }
  }, [pairLineObj.loading]);

  /*React.useEffect(() => {
    if (selectedPair !== '') {
      setModelObj({
        ...modelObj,
        modalActionDisable: false,
      })
    }
  }, [selectedPair])*/

  const handleInvitation = () => {
    if (isUserEmailExists) {
      setOpen(false);
      setIsUserEmailExists(false);
    } else {
      if (sharedLines?.noofAttempts === 3) {
        //|| (sharedLines.isAssignee && sharedLines.error)
        window.open(sharedLinesContent.contactHelp, "_blank");
        setOpen(false);
      } else {
        const isAssign = sharedLineObj.isAssign;
        setSharedLineObj({
          ...sharedLineObj,
          emailDisable: true,
          isEmailRequired: false,
        });

        if (!isAssign) {
          setModelObj({
            ...sharedLinesContent.invitaion,
            title: sharedLinesContent.invitaion.title.replace(
              "$DeviceName",
              deviceName
            ),
            closeActionDisable: true,
            modalActionDisable: true,
            isPending: true,
          });
        } else {
          setModelObj({
            ...sharedLinesContent.onAsign,
            title: sharedLinesContent.onAsign.title.replace(
              "$DeviceName",
              deviceName
            ),
            closeActionDisable: true,
            modalActionDisable: true,
            isPending: true,
          });
        }
        dispatch(
          sendInvitationInitiated({
            msisdn: id.slice(1),
            granteeEmail: isAssign ? userinfo.email : sharedLineObj.email,
            grantorEmail: userinfo.email,
            isAssignee: isAssign,
            lineType: lineType,
            MSISDN: id,
            ownerFirstName: userinfo.firstName,
          })
        );
        setTimeout(function () {
          if (
            sharedLines.error === "" &&
            sharedLines.language === "" &&
            sharedLines.toastMessage
          ) {
            dispatch(setLongRunningQuery());
            handleCloseBtn();
          }
        }, 3000);
      }
    }
  };

  const onPencilClick = () => {
    setActionIcons((prevState: any) => {
      return {
        ...prevState,
        assign: { ...prevState.assign, show: false },
        pencil: { ...prevState.pencil, show: false },
        cancel: { ...prevState.cancel, show: true },
        share: { ...prevState.share, show: false },
        save: { ...prevState.save, show: false },
      };
    });
    onEdit();
    // //console.log(editDeviceRef, 'editDeviceRef')
    // setTimeout(() => {
    //   editDeviceRef.current.focus();
    // }, 500);
  };

  const handleMSISDN = (msisdn: string) => {
    return msisdn.length > 10
      ? `${msisdn.slice(0, 1)}(${msisdn.slice(1, 4)}) ${msisdn.slice(
          4,
          7
        )}-${msisdn.slice(7, 11)} `
      : ``;
  };

  const getDevicePairedDetails = (id: any) => {
    const pairedLines: any = filterPairLines();
    const pairedLine = pairedLines.find((line: any) => line.MSISDN === id);

    if (pairedLine) {
      return (
        <>
          Paired with: &nbsp;{pairedLine.givenName}&nbsp;-&nbsp;
          <span>{handleMSISDN(pairedLine.MSISDN)}</span>
        </>
      );
      // return `Paired with: ${pairedLine.givenName} ${handleMSISDN(
      // pairedLine.MSISDN
      //)}`;
    }
    return "";
  };

  const unpairHandler = (data: any) => {
    if (type === "delveDetails" && categoryID === Category.wearblesID) {
    } else {
      if (!isMobile) setIsHover(false);
    }
    unpairCB && unpairCB(data);
  };

  const pairHandler = (data: any) => {
    if (!isMobile) setIsHover(false);
    pairCB && pairCB(data);
  };

  const onShareClick = () => {
    dispatch(resetInvitation(id));
    setSharedLineObj({
      ...sharedLineObj,
      email: "",
      isEmailRequired: true,
      emailDisable: false,
      isAssign: false,
    });
    setModelObj({
      ...sharedLinesContent.invitaion,
      title: sharedLinesContent.invitaion.title.replace(
        "$DeviceName",
        deviceName
      ),
      closeAction: handleCloseBtn,
    });
    setOpen(true);
    setActionIcons((prevState: any) => {
      return {
        ...prevState,
        share: { ...prevState.share, show: false },
      };
    });
  };

  const closeDialog = () => {
    setOpen(false);
    dispatch(updateLoader(false));
    dispatch(clearApiCallStatus({ module: SavingTypes.UPDATE_SAVING_NAME }));
  };

  const onSaveClick = () => {
    if (nameApiStatus?.noOfAttempts === 3) {
      window.open(sharedLinesContent.contactHelp, "_blank");
      closeDialog();
    } else if (nameApiStatus?.status === "error") {
      setModelObj({
        ...modelObj,
        status: "updating...",
        isPending: true,
      });
      dispatch(
        updateSavingName({ id: id, givenName: contactName.trim(), categoryID })
      );
    } else {
      var updatedContactName: any;
      setContactName((currentState) => {
        updatedContactName = currentState;
        return currentState;
      });
      updatedContactName = updatedContactName
        ? updatedContactName.trim()
        : contactName;

      setIsEdit(false);
      setOpenMenuItem(false);
      if (isMobile) {
        setActionIcons(actionIconsList);
      } else {
        setActionIcons((prevState: any) => {
          return {
            ...prevState,
            save: { ...prevState.save, show: false },
            cancel: { ...prevState.cancel, show: false },
          };
        });
      }

      dispatch(
        updateSavingName({ id: id, givenName: updatedContactName, categoryID })
      );
    }
  };

  const onCancelClick = () => {
    setActionIcons(actionIconsList);
    setIsEdit(false);
    dispatch(setEditingID({ id: "" }));
  };

  const onAsignClick = () => {
    dispatch(resetInvitation(id));
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
      isAssign: true,
    });
    setModelObj({
      ...sharedLinesContent.onAsign,
      closeAction: handleCloseBtn,
    });
    setOpen(true);
    setActionIcons((prevState: any) => {
      return {
        ...prevState,
        assign: { ...prevState.share, show: false },
      };
    });
  };

  const expandCB = () => {
    setCollapseOpen((prevState) => !prevState);
  };

  const leaveCB = () => {
    removeCB && removeCB({ deviceName, id });
  };

  const actionIconsList = {
    pencil: {
      callBack: onPencilClick,
      position: "left",
      toolTipText: "Edit line name",
      show: isEditable && type === "lineDetails" ? true : false,
    },
    share: {
      callBack: onShareClick,
      position: "right",
      toolTipText: "Share the line with someone",
      show: isShareble && type !== "delveDetails" ? true : false,
    },
    save: {
      callBack: onSaveClick,
      position: "right",
      toolTipText: "Save changes to line name",
      show: false,
    },
    cancel: {
      callBack: onCancelClick,
      position: "right",
      toolTipText: "Cancel changes to line name",
      show: type === "delveDetails" ? true : false,
    },
    assign: {
      callBack: onAsignClick,
      position: "right",
      toolTipText: "Add me to this line",
      show: categoryID === Category.unAssignedID ? true : false,
    },
    remove: {
      callBack: removeCB,
      position: "right",
      toolTipText: "Remove line",
      show:
        categoryID === Category.unAssignedID ||
        categoryID === Category.wearblesID
          ? false
          : type === "delveDetails" && isRemovable === true
          ? true
          : false,
    },
    pair: {
      callBack: pairHandler,
      position: "right",
      toolTipText: "Pair",
      show:
        categoryID === Category.wearblesID
          ? isPared === false
            ? true
            : false
          : false,
    },
    unpair: {
      callBack: unpairHandler,
      position: "right",
      toolTipText: "Unpair",
      show:
        categoryID === Category.wearblesID
          ? isPared === true
            ? true
            : false
          : false,
    },
    leave: {
      callBack: leaveCB,
      position: "right",
      toolTipText: "Leave this line",
      show: categoryID === Category.lineSharedID ? true : false,
    },
  };

  useEffect(() => {
    if (
      sharedLines?.language !== "" &&
      sharedLines.toastMessage &&
      sharedLines?.error === ""
    ) {
      setSharedLineObj({
        ...sharedLineObj,
        isEmailRequired: false,
        language: sharedLines.language,
      });
      if (sharedLines.msisdn === id) {
        let message;
        if (sharedLines.isAssignee) {
          message = sharedLinesContent.success?.messageAssignee.replace(
            "$deviceName",
            deviceName
          );
        } else {
          message = sharedLinesContent.success?.messageShare.replace(
            "$deviceName",
            deviceName
          );
        }
        dispatch(success(message));
        dispatch(resetToastMessage());
      }

      setOpen(false);
    }

    if (sharedLines?.error) {
      if (sharedLines.error === "ALREADY EMAIL EXISTS") {
        //dispatch(success("ALREADY EMAIL EXISTS"))
        setIsUserEmailExists(true);
        var content = sharedLinesContent.userEXistsError.content;
        content = content.replace("$email", sharedLineObj.email);
        content = content.replace("$deviceName", deviceName);
        setModelObj({
          ...sharedLinesContent.userEXistsError,
          content: content,
        });
      } else {
        setSharedLineObj({
          ...sharedLineObj,
          isEmailRequired: false,
        });
        if (!sharedLines.isAssignee) {
          setModelObj({
            ...sharedLinesContent.serverBusy,
            content: sharedLinesContent.serverBusy.content.replace(
              "$email",
              sharedLineObj.email
            ),
            closeAction: handleCloseBtn,
          });
          if (sharedLines?.noofAttempts === 3) {
            setSharedLineObj({
              ...sharedLineObj,
              isEmailRequired: true,
              emailDisable: false,
            });
            setModelObj({
              ...sharedLinesContent.resend,
              title: sharedLinesContent.resend.title.replace(
                "$DeviceName",
                deviceName
              ),
              modalActionDisable: false,
              closeAction: handleCloseBtn,
            });
          }
          if (sharedLines?.noofAttempts === 3) {
            setSharedLineObj({
              ...sharedLineObj,
              isEmailRequired: false,
            });
            setModelObj({
              ...sharedLinesContent.oops,
              closeAction: handleCloseBtn,
            });
          }
        } else {
          setSharedLineObj({
            ...sharedLineObj,
            isEmailRequired: false,
            isAssign: true,
          });
          if (sharedLines?.noofAttempts === 3) {
            setModelObj({
              ...sharedLinesContent.oops,
              closeAction: handleCloseBtn,
            });
          } else {
            setModelObj({
              ...sharedLinesContent.serverBusy,
              content: sharedLinesContent.serverBusy.content.replace(
                "$email",
                userinfo.email
              ),
              closeAction: handleCloseBtn,
            });
          }
        }
      }
    }
  }, [sharedLines]);

  useEffect(() => {
    setActionIcons(actionIconsList);
  }, []);
  useEffect(() => {
    setActionIcons(actionIconsList);
  }, [isPared]);

  useEffect(() => {
    if (assigneeMsisdn !== "") {
      setTimeout(function () {
        dispatch(resetAssigneeMsisdn());
      }, 3000);
    }
  }, [assigneeMsisdn]);

  const handleMouseEnter = () => {
    if (actionIcons?.save?.show || currentEditingID !== "") {
    } else if (isRemovable === false && type === "delveDetails") {
    } else {
      if (!isMobile) {
        setIsHover(true);
      }
      setActionIcons(actionIconsList);
    }
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (typeof ele === "string") {
      const targetEle: any = document.querySelector("#" + ele);
      if (event.keyCode === 9) {
        // targetEle.nextSibling.querySelector('span').focus()
      }
      if (event.keyCode === 13) {
        targetEle.click();
      }
    } else {
      if (event.keyCode === 13) {
        ele.current.click();
      }
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      if (
        (actionIcons && actionIcons.save && actionIcons.save.show) ||
        currentEditingID === id
      ) {
      } else {
        if (!isMobile) {
          setIsHover(false);
        }
        setIsEdit(false);
        setContactName(deviceName);
      }
    }
  };

  // useEffect(()=>{
  //   debugger
  //   setTimeout(function () {
  //     setIsMobile(isMobileOrTablet())
  //     console.log("isMobileOrTablet"+isMobileOrTablet())
  //       handleMouseEnter();
  //       //handleMouseLeave();
  //   },1000);

  //     },[navigator.userAgent])

  const onEdit = (): void => {
    setIsEdit(true);
    setContactName(deviceName);
    dispatch(setEditingID({ id }));
  };

  const onSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactName(e.target.value);
    if (actionIcons.pencil.show === false) {
      if (e.target.value && e.target.value.trim()) {
        setActionIcons((prevState: any) => {
          return {
            ...prevState,
            save: { ...prevState.save, show: true },
          };
        });
      } else {
        setActionIcons((prevState: any) => {
          return {
            ...prevState,
            save: { ...prevState.save, show: false },
          };
        });
      }
    }
  };

  const ClearEditInput = () => {
    setContactName("");
    setActionIcons((prevState: any) => {
      return {
        ...prevState,
        save: { ...prevState.save, show: false },
      };
    });
  };

  const OnInputFocus = () => {};

  const calWidth = () => {
    if (contactName.length > 80) {
      return contactName.length * 10 - 10 + "px";
    } else {
      return 50 + contactName.length * 10 + "px";
    }
  };

  const dialogAction = (title: string) => {
    if (nameApiStatus?.status === "error") {
      return onSaveClick;
    }
    switch (title) {
      default:
        return handleInvitation;
    }
  };

  const onLineSelect = () => {
    dispatch(
      setSelectedLine({
        id,
        deviceName,
        displayNumber,
        category,
        lineType,
        imsi,
        categoryID,
      })
    );
    navigate("/line-delve");
  };

  const isAllowClick = () => {
    return (
      !isEdit &&
      currentEditingID === "" &&
      (categoryID === Category.assignedID ||
        categoryID === Category.unAssignedID ||
        categoryID === Category.lineSharedID)
    );
  };

  const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = content.Regex.emailValidation;
    const email = e.target.value;
    setSharedLineObj({
      ...sharedLineObj,
      email: email,
    });
    if (email) {
      setModelObj({
        ...modelObj,
        modalActionDisable: !regex.test(email),
      });
    }
  };

  const [selectedTooltip, setSelectedTooltip] = React.useState(false);

  const handleTooltip = () => {
    setSelectedTooltip(true);
  };

  const handleCloseTooltip = () => {
    setSelectedTooltip(false);
  };

  return (
    <>
      <div
        className={`numberCardContainer ${isHover ? "selected" : ""} ${
          updatedNameID === id && type === "lineDetails" ? "updated" : ""
        }`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onFocus={handleMouseEnter}
        onKeyUp={(event: any) => {
          if (event.shiftKey && event.keyCode === 9) handleMouseEnter();
        }}
        onKeyDown={(event: any) => {
          if (event.shiftKey && event.keyCode === 9) handleMouseLeave();
        }}
      >
        {deviceAvataar !== "" && (
          <DeviceAvataar
            src={deviceAvataar}
            title={
              icon === "VirtualLine"
                ? "Virtual Line"
                : icon === "Wearable"
                ? "Paired Device"
                : "SIM-based Voice Line"
            }
            placement="top"
          />
        )}

        <div className="contentContainer">
          <div
            className={`details ${type === "delveDetails" && "delve-details"}`}
          >
            <div
              tabIndex={0}
              id={"device-line" + id}
              className={`leftContent ${
                type === "delveDetails" && "leftContent-delveDetails"
              } ${
                (categoryID === Category.assignedID ||
                  categoryID === Category.unAssignedID ||
                  categoryID === Category.lineSharedID) &&
                !isEdit &&
                "leftContent-hover"
              }`}
              onKeyUp={(event) => {
                
                type !== "delveDetails" &&
                  handleKeyUp(event, "device-line" + id);
                if (event.keyCode === 13 && isAllowClick()) {
                  onLineSelect();
                }
              }}
            >
              {!isEdit && (
                <>
                  {categoryID === Category.wearblesID &&
                  type === "delveDetails" ? (
                    <span
                      className={`Name-of-line Name-of-line-delveDetails  Name-of-line-delveDetails--bold`}
                      onClick={isAllowClick() ? onLineSelect : undefined}
                    >
                      <Highlight search={searchKey.realKey}>
                        {deviceName + " - " + handleMSISDN(displayNumber)}{" "}
                      </Highlight>
                    </span>
                  ) : (
                    <span className="unpairedBox">
                      <span
                        className={`Name-of-line d-flex ${
                          type === "delveDetails"
                            ? "Name-of-line-delveDetails"
                            : ""
                        } 
                    ${!isPared ? `name-unpaire-icon` : ""}`}
                      >
                        <Highlight
                          search={searchKey.realKey}
                          onClick={isAllowClick() ? onLineSelect : undefined}
                        >
                          {lineDeviceName}
                        </Highlight>
                        {isHover &&
                          !loading &&
                          !isMobile &&
                          // isPared &&
                          actionIcons && (
                            <span className="edit-icons-is-paired">
                              <EditLineIcons
                                actions={actionIcons}
                                type={type}
                              />
                            </span>
                          )}
                        {loading && currentEditingID === id && (
                          <span className="spinner"></span>
                        )}
                        {/* {showSelfTag() && "(Self)"} */}
                        {categoryID === Category.wearblesID && !isPared && (
                          <Tooltip
                            title={
                              <>
                                <div className="tooltipClose">
                                  <img
                                    src={iconClose}
                                    alt={"close"}
                                    width="14px"
                                    height={"14px"}
                                    onClick={() => handleCloseTooltip()}
                                  />
                                </div>
                                {content.unPaireTitle}
                              </>
                            }
                            placement={"top"}
                            open={selectedTooltip}
                          >
                            <img
                              src={UnpairIcon}
                              className="unpairIcon"
                              onClick={() => handleTooltip()}
                            />
                          </Tooltip>
                        )}
                      </span>
                    </span>
                  )}
                </>
              )}
              {isEdit && (
                <span className="d-flex">
                  <TextField
                    className="editNumber"
                    style={{
                      height: "24px",
                      width: calWidth(),
                      border: "0px",
                      marginRight: "15px",
                    }}
                    onChange={onSearchInput}
                    value={contactName}
                    onFocus={OnInputFocus}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        if (actionIcons && actionIcons.save?.show) {
                          onSaveClick();
                        }
                      }
                    }}
                    tabIndex={0}
                    inputProps={{
                      maxLength: CHARACTER_LIMIT,
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {contactName.length >= 90 && (
                            <span>
                              {" "}
                              {`${contactName.length}/${CHARACTER_LIMIT}`}
                            </span>
                          )}
                          {isEdit && (
                            <IconButton
                              edge="end"
                              onClick={ClearEditInput}
                              className="clearButton"
                              style={{ padding: 0 }}
                            >
                              <CloseIcon />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {isHover &&
                    !loading &&
                    !isMobile &&
                    //&& isPared
                    actionIcons && (
                      <span className=" saveEdit">
                        <EditLineIcons actions={actionIcons} type={type} />
                      </span>
                    )}
                  {loading && currentEditingID === id && (
                    <span className="spinner"></span>
                  )}
                </span>
              )}

              {(categoryID !== Category.wearblesID ||
                type !== "delveDetails") && (
                <div
                  className={`displaynumber-container  ${
                    !isPared ? `unpaired-con` : ``
                  }`}
                >
                  {displayNumber !== "" && (
                    <div className="phoneNumber">
                      <Highlight
                        search={
                          displayNumber.includes(searchKey?.realKey)
                            ? searchKey?.realKey
                            : searchKey?.formattedKey
                        }
                        onClick={isAllowClick() ? onLineSelect : undefined}
                      >
                        {categoryID === Category.wearblesID &&
                        type !== "delveDetails"
                          ? displayNumber
                          : displayNumber}
                      </Highlight>
                    </div>
                  )}
                  {categoryID === Category.wearblesID && (
                    <div
                      className={
                        isPared
                          ? "device device--paired"
                          : "device device--unpaired"
                      }
                    >
                      <Highlight
                        search={
                          displayNumber.includes(searchKey?.realKey)
                            ? searchKey?.realKey
                            : searchKey?.formattedKey
                        }
                      >
                        {isPared === true
                          ? getDevicePairedDetails(pairedDevice)
                          : "Unpaired"}
                      </Highlight>
                    </div>
                  )}
                </div>
              )}
            </div>

            {isHover && !loading && (
              <>
                {isMobile && type !== "delveDetails" && (
                  <div className="menu-button">
                    <Button onClick={handleClickMenu}>
                      <MenuIcon />
                    </Button>
                    {openMenuItem && (
                      <div ref={ref}>
                        <IconListMobile
                          actions={actionIcons}
                          type={type}
                          data={payload_Iconslist}
                        ></IconListMobile>
                      </div>
                    )}
                  </div>
                )}
                {isMobile && type === "delveDetails" && (
                  <IconListDevMobile
                    actions={actionIcons}
                    deviceData={
                      deviceData && deviceData.length > 0 ? true : false
                    }
                    data={payload_Iconslist}
                  />
                )}
                {!isMobile && (
                  <IconList
                    actions={actionIcons}
                    type={type}
                    data={payload_Iconslist}
                    isPared={true}
                    tabIndex={0}
                    handleMouseLeave={handleMouseLeave}
                  ></IconList>
                )}
              </>
            )}
            {deviceData && deviceData.length > 0 && type === "delveDetails" && (
              <div className="expandAction">
                {!collapseOpen ? (
                  <span
                    onClick={() => expandCB()}
                    tabIndex={0}
                    ref={expandMoreRef}
                    onKeyUp={(event) => handleKeyUp(event, expandMoreRef)}
                  >
                    <ExpandMore />
                  </span>
                ) : (
                  <span
                    onClick={() => expandCB()}
                    tabIndex={0}
                    ref={expandLessRef}
                    onKeyUp={(event) => handleKeyUp(event, expandLessRef)}
                  >
                    <ExpandLess />
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="divider" />
        </div>
        <ModalDialog
          openModal={open}
          modelObj={modelObj}
          dialogAction={dialogAction(modelObj.title)}
          //uniquId={id + "_" + new Date().getMilliseconds()}
        >
          {sharedLineObj?.isEmailRequired && (
            <TextField
              size="small"
              id={`email-${id}`}
              variant="outlined"
              onChange={handleEmail}
              disabled={sharedLineObj.emailDisable}
              value={sharedLineObj.email}
              fullWidth
              placeholder="Email address"
            />
          )}
        </ModalDialog>
      </div>
      {deviceData && deviceData.length > 0 && (
        <LineCollapse
          owner={userinfo.orig_tmobileid || ""}
          open={collapseOpen}
          onDeactivate={deactivateCB ? deactivateCB : () => {}}
          deviceList={deviceData}
          keyData={id}
        ></LineCollapse>
      )}
    </>
  );
};
export default NumberCard;
